$(document).ready(function() {
    $('.closeModal').click(function(){
        $('body').removeClass('locked');
        $('#modal').removeClass('active');
    });

    $('.jsModal').click(function(){
        $('body').addClass('locked');
        $('#modal').addClass('active');
    });

    $('.tabs a').click(function(){
        $('.tabs li').removeClass('active');
        $(this).closest('li').addClass('active');
        $('.tab').addClass('d-none');
        $($(this).attr('data-target')).removeClass('d-none');

        $('#dum-plan img').attr('src',$(this).attr('data-plan'));
        $('#dum-img img').attr('src',$(this).attr('data-img'));
        $('#dum-img').attr('href',$(this).attr('data-img-oreginal'));

    });

    $(".jsLink").click(function(){
         window.location=$(this).find("a").attr("href");
         return false;
    });

    $('.jsGallery').click(function(){
        $('.jsGallery').addClass('white');
        $(this).removeClass('white');
        $('.photos').addClass('d-none');
        $($(this).attr('data-id')).removeClass('d-none');
        $('.lazy').lazy({
          effect: "fadeIn",
          effectTime: 500,
          threshold: 0,
          afterLoad: function(element) {
               element.removeClass('blurLoading');
           },
        });
    });

    $('.standardBtn').click(function(){
        console.log('click');
        $('.standardBtn').removeClass('active');
        $(this).addClass('active');
        $('.standar').addClass('hidden');
        $('#etapa-'+$(this).attr('data-id')).removeClass('hidden');
    });

    $('.jsStandardBtn').click(function(){
        $('.jsStandardBtn').removeClass('bg-color-3 color-1').addClass('bg-color-1 color-3');
        $(this).removeClass('bg-color-1 color-3').addClass('bg-color-3 color-1');
        $('.stands').addClass('hidden');
        $('.'+$(this).attr('data-type')).removeClass('hidden');
    });

     $('select').selectric({  forceRenderAbove: false});
     $('.selectLink').on('change', function() {
         location.href=$(this).val()+'#vyber-jednotky';
    });

    $('.ajaxFilter').on('change', function() {
        $('#filtr').submit();
     });



   var animBool   = false;
   if(animBool == false && $('body').find('.numbers').length == 1){
       $(window).on('scroll', function () {
           var cur_pos = $(this).scrollTop();

           nr = $('.numbers').offset().top;

           if((nr - $( window ).height()) < cur_pos){

               if(!animBool){
                   animBool = true;
                   animateCounter($('.numbers'));
               }
           }
        });
    }
});


function animateCounter(obj){
        obj.addClass('active');
        obj.find('big').each(function () {

            $(this).prop('Counter',0).animate({
                Counter: $(this).text()
            }, {
                duration: 1500,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });
}
